import React, { useMemo, useState } from "react";

const STORAGE_KEY = "logboek24.monteur.toolbox";
const TOOLBOX_ITEMS = [
  "PBM gecontroleerd",
  "Werkplek veilig vrijgegeven",
  "Ladder/hoogtewerk beoordeeld",
  "Brandveiligheid gecontroleerd",
  "Nooduitgangen vrij",
  "Risico's gemeld aan leidinggevende",
];

export default function MonteurToolboxPage() {
  const [state, setState] = useState(() => loadState());

  const completedCount = useMemo(
    () => TOOLBOX_ITEMS.filter((item) => Boolean(state?.checks?.[item])).length,
    [state]
  );

  function setCheck(item, checked) {
    setState((prev) => {
      const next = {
        ...prev,
        checks: {
          ...(prev?.checks || {}),
          [item]: checked,
        },
      };
      persist(next);
      return next;
    });
  }

  function setComment(value) {
    setState((prev) => {
      const next = { ...prev, comment: value };
      persist(next);
      return next;
    });
  }

  function reset() {
    const next = emptyState();
    setState(next);
    persist(next);
  }

  return (
    <div className="space-y-4">
      <section className="rounded-xl border bg-white p-5 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900">Toolbox</h2>
        <p className="mt-1 text-sm text-gray-600">
          Dagelijkse veiligheidscheck voor de start van het werk.
        </p>
      </section>

      <section className="rounded-xl border bg-white p-5 shadow-sm">
        <div className="mb-3 flex items-center justify-between gap-2">
          <p className="text-sm font-medium text-gray-800">Checklist vandaag</p>
          <div className="flex items-center gap-2">
            <span className="rounded-full bg-slate-100 px-2 py-1 text-xs text-slate-700">
              {completedCount}/{TOOLBOX_ITEMS.length}
            </span>
            <button
              type="button"
              onClick={reset}
              className="rounded border px-2 py-1 text-xs text-gray-700 hover:bg-gray-50"
            >
              Reset
            </button>
          </div>
        </div>

        <div className="space-y-2">
          {TOOLBOX_ITEMS.map((item) => (
            <label key={item} className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={Boolean(state?.checks?.[item])}
                onChange={(event) => setCheck(item, event.target.checked)}
              />
              <span>{item}</span>
            </label>
          ))}
        </div>

        <div className="mt-4">
          <label className="mb-1 block text-sm font-medium text-gray-700">Opmerking</label>
          <textarea
            rows={4}
            value={state.comment}
            onChange={(event) => setComment(event.target.value)}
            placeholder="Bijzonderheden of veiligheidsmelding"
            className="w-full rounded border p-2 text-sm"
          />
        </div>
      </section>
    </div>
  );
}

function emptyState() {
  return {
    checks: {},
    comment: "",
  };
}

function loadState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyState();
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return emptyState();
    return {
      checks: parsed.checks && typeof parsed.checks === "object" ? parsed.checks : {},
      comment: String(parsed.comment || ""),
    };
  } catch {
    return emptyState();
  }
}

function persist(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore storage errors
  }
}
